<template>
  <div class="qc-page">
    <!-- 模块1：Banner -->
    <section class="qc-banner">
      <div class="qc-banner-bg">
        <img src="/banner-超级店长背景图.jpg" alt="" class="qc-banner-bg-img" />
      </div>
      <div class="container-responsive qc-container qc-banner-inner">
        <div class="qc-banner-grid">
          <AnimatedSection>
            <h1 class="qc-banner-title">千橙AI超级店长</h1>
            <h2 class="qc-banner-subtitle">零售门店AI经营助手</h2>
            <p class="qc-banner-desc">
              面向零售门店与连锁商，覆盖选品、营销、运营、销售、社群、客服等8大经营场景，搭载15+专属AI智能体，让每个门店都拥有AI超级店长。
            </p>
            <!-- 4个数据展示 -->
            <div class="qc-banner-stats">
              <div class="qc-banner-stat">
                <div class="qc-banner-stat-num">25万+</div>
                <div class="qc-banner-stat-label">已服务门店</div>
              </div>
              <div class="qc-banner-stat">
                <div class="qc-banner-stat-num">8大</div>
                <div class="qc-banner-stat-label">经营场景</div>
              </div>
              <div class="qc-banner-stat">
                <div class="qc-banner-stat-num">15+</div>
                <div class="qc-banner-stat-label">AI智能体</div>
              </div>
              <div class="qc-banner-stat">
                <div class="qc-banner-stat-num">21省</div>
                <div class="qc-banner-stat-label">覆盖省份</div>
              </div>
            </div>
            <a href="https://shop.qcos.cn/" target="_blank" rel="noopener noreferrer" class="qc-btn qc-btn-primary qc-btn-w180">
              <span class="qc-btn-text">立即体验</span>
              <LucideIcon name="arrow-right" :size="16" class="qc-btn-arrow" />
            </a>
          </AnimatedSection>
          <AnimatedSection :delay="200">
            <div class="qc-banner-figure">
              <img src="/banner-超级店长右边图.png" alt="千橙AI超级店长 配图" class="qc-banner-figure-img" />
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块2：零售门店四大经营痛点 -->
    <section class="qc-section qc-section-gray">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">零售门店四大经营痛点</h2>
            <p class="qc-section-desc">
              超600万终端门店，万亿级市场，每个痛点都对应一项AI核心能力
            </p>
          </div>
        </AnimatedSection>
        <div class="qc-grid-2">
          <AnimatedSection v-for="(item, i) in challenges" :key="i" :delay="i * 100" class="qc-challenge-anim">
            <div class="qc-challenge-card">
              <div class="qc-challenge-body">
                <h3 class="qc-challenge-title">{{ item.title }}</h3>
                <p class="qc-challenge-desc">{{ item.desc }}</p>
                <ul class="qc-challenge-tags">
                  <li v-for="(tag, j) in item.tags" :key="j" class="qc-challenge-tag">
                    <span class="qc-challenge-bullet">•</span>
                    <span>{{ tag }}</span>
                  </li>
                </ul>
                <div class="qc-challenge-foot">
                  <span class="qc-challenge-pill">
                    <svg class="qc-check-icon qc-check-icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {{ item.tag }}
                  </span>
                </div>
              </div>
              <!-- 右下角配图 -->
              <div class="qc-challenge-img-wrap">
                <img :src="item.image" :alt="item.title" class="qc-challenge-img" />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块4：千橙AI超级店长APP四大能力 -->
    <section class="qc-section qc-section-white">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">千橙AI超级店长APP四大能力</h2>
            <p class="qc-section-desc">
              四大能力精准破解四大痛点，对话式指令，AI店长自主完成任务并结果交付
            </p>
          </div>
        </AnimatedSection>
        <div class="qc-grid-2">
          <AnimatedSection v-for="(item, i) in capabilities" :key="i" :delay="i * 100">
            <div class="qc-cap-card">
              <div class="qc-cap-head">
                <div class="qc-cap-icon-box" :style="{ backgroundColor: item.iconBg }">
                  <LucideIcon :name="item.icon" :size="20" class="qc-cap-icon" />
                </div>
                <h3 class="qc-cap-title">{{ item.title }}</h3>
              </div>
              <p class="qc-cap-desc">{{ item.desc }}</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块5：全链路步骤条 -->
    <section class="qc-section qc-section-gray">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">AI建站→选品→营销→销售→分析→补货全链路</h2>
            <p class="qc-section-desc">
              围绕零售店社群私域经营场景，提供从"搭场、销售、分析到补货"的一站式智能卖货服务
            </p>
          </div>
        </AnimatedSection>

        <div class="qc-steps">
          <div v-for="(step, idx) in fullChainSteps" :key="idx" class="qc-step-row">
            <!-- 左边步骤 -->
            <div
              class="qc-step-tab"
              :class="{ 'qc-step-tab-active': isStepActive(idx) }"
              @mouseenter="activeStep = idx"
              @click="activeStep = idx"
            >
              <div class="qc-step-tab-inner">
                <div class="qc-step-tab-text">
                  <div class="qc-step-num">{{ pad2(idx + 1) }}</div>
                  <div class="qc-step-tab-title">{{ step.title }}</div>
                </div>
                <div class="qc-step-bar" :class="{ 'qc-step-bar-active': isStepActive(idx) }"></div>
              </div>
            </div>

            <!-- 右边卡片 -->
            <div
              class="qc-step-card"
              :class="isStepActive(idx) ? 'qc-step-card-open' : 'qc-step-card-collapsed'"
              @mouseenter="activeStep = idx"
              @click="activeStep = idx"
            >
              <!-- 展开状态：完整内容 -->
              <div v-if="isStepActive(idx)" class="qc-step-open">
                <!-- 左边文字内容 - 70% -->
                <div class="qc-step-content">
                  <div class="qc-step-content-head">
                    <h3 class="qc-step-title">{{ step.title }}</h3>
                    <span class="qc-step-highlight">{{ step.highlight }}</span>
                  </div>
                  <p class="qc-step-intro">{{ step.intro }}</p>
                  <div class="qc-step-advantages">
                    <div v-for="(adv, i) in step.advantages" :key="i" class="qc-step-advantage">
                      <svg class="qc-check-icon qc-step-check" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span class="qc-step-advantage-text">{{ adv }}</span>
                    </div>
                  </div>
                  <div class="qc-step-agents">
                    <p class="qc-step-agents-label">配套智能体</p>
                    <div class="qc-step-agent-list">
                      <span v-for="(agent, i) in step.agents" :key="i" class="qc-step-agent">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                          <line x1="9" y1="9" x2="15" y2="9" />
                          <line x1="9" y1="15" x2="15" y2="15" />
                        </svg>
                        {{ agent }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 右边配图 - 30% -->
                <div class="qc-step-figure">
                  <div class="qc-step-img-box">
                    <img :src="step.image" :alt="step.title" class="qc-step-img" />
                  </div>
                </div>
              </div>
              <!-- 收起状态：只显示标题和介绍 -->
              <div v-else class="qc-step-collapsed">
                <h3 class="qc-step-collapsed-title">{{ step.title }}</h3>
                <span class="qc-step-collapsed-intro">{{ step.intro }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 模块6：AI能力数据说话 -->
    <section class="qc-section qc-section-white">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">AI 能力数据说话</h2>
            <p class="qc-section-desc">每一项能力都有可量化的业务结果</p>
          </div>
        </AnimatedSection>
        <div class="qc-grid-4">
          <AnimatedSection v-for="(card, idx) in dataCards" :key="idx" :delay="idx * 0.1" class="qc-data-anim">
            <div class="qc-data-card">
              <div class="qc-data-head">
                <LucideIcon :name="card.icon" :size="20" class="qc-data-icon" />
                <h3 class="qc-data-title">{{ card.title }}</h3>
              </div>
              <div class="qc-data-list">
                <div v-for="(item, i) in card.data" :key="i" class="qc-data-row">
                  <span class="qc-data-label">{{ item.label }}</span>
                  <span class="qc-data-value">{{ item.value }}</span>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块7：多层级连锁门店管理体系 -->
    <section class="qc-section qc-section-white qc-section-chain">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">多层级连锁门店管理体系</h2>
            <p class="qc-section-desc">以效率链接，用数据赋能，提升品牌连锁管理效率和质量</p>
          </div>
        </AnimatedSection>

        <!-- 上半部：3个模式卡片 -->
        <div class="qc-grid-3 qc-modes">
          <AnimatedSection v-for="(mode, idx) in modeCards" :key="idx" :delay="idx * 0.1">
            <div class="qc-mode-card">
              <div class="qc-mode-icon-box">
                <LucideIcon :name="mode.icon" :size="32" class="qc-mode-icon" />
              </div>
              <h3 class="qc-mode-title">{{ mode.title }}</h3>
              <p class="qc-mode-desc">{{ mode.desc }}</p>
              <p class="qc-mode-sub">{{ mode.sub }}</p>
            </div>
          </AnimatedSection>
        </div>

        <!-- 下半部：六通体系 -->
        <AnimatedSection>
          <div class="qc-liutong-head">
            <h3 class="qc-liutong-title">六通体系 · 全链路数字化管理</h3>
          </div>
        </AnimatedSection>
        <div class="qc-grid-3 qc-liutong-grid">
          <AnimatedSection v-for="(item, idx) in sixTong" :key="idx" :delay="idx * 0.05">
            <div class="qc-liutong-card">
              <div class="qc-liutong-icon-box">
                <LucideIcon :name="item.icon" :size="24" class="qc-liutong-icon" />
              </div>
              <div class="qc-liutong-text">
                <h4 class="qc-liutong-name">{{ item.title }}</h4>
                <p class="qc-liutong-desc">{{ item.desc }}</p>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块9：客户案例 -->
    <section class="qc-section qc-section-gray">
      <div class="container-responsive qc-container">
        <AnimatedSection>
          <div class="qc-section-head">
            <h2 class="qc-section-title">客户案例</h2>
            <p class="qc-section-desc">
              真实业务增长验证-AI驱动经营业绩与经营质量双增长
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection>
          <div class="qc-case-grid">
            <!-- 左侧 60% -->
            <div class="qc-case-left">
              <div class="qc-case-heading">
                <div class="qc-case-label">国潮美妆品牌</div>
                <h3 class="qc-case-title">全国112家连锁门店 · 即时零售转型</h3>
              </div>
              <p class="qc-case-desc">
                该品牌拥有全国百余家连锁门店，面临线上订单分散、门店接单效率低、夜间配送能力不足等痛点。通过千橙AI超级店长部署智能订单路由、AI运力调度与智能接单提醒系统，推动门店O2O即时零售全面升级，实现异地门店高效协同与夜间经济突破。
              </p>

              <!-- 4个亮点 - 2x2布局 -->
              <div class="qc-case-highlights">
                <div v-for="(h, i) in caseHighlights" :key="i" class="qc-case-highlight">
                  <h4 class="qc-case-highlight-title">
                    <svg class="qc-check-icon qc-case-check" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                    </svg>
                    {{ h.title }}
                  </h4>
                  <p class="qc-case-highlight-desc">{{ h.desc }}</p>
                </div>
              </div>

              <!-- 3个数据 -->
              <div class="qc-case-stats">
                <div v-for="(s, i) in caseStats" :key="i" class="qc-case-stat">
                  <div class="qc-case-stat-num">{{ s.num }}</div>
                  <div class="qc-case-stat-label">{{ s.label }}</div>
                </div>
              </div>
            </div>
            <!-- 右侧 40% - 配图 -->
            <div class="qc-case-right">
              <div class="qc-case-badge">美妆连锁 · O2O升级</div>
              <img src="/客户案例超级店长.jpg" alt="美妆连锁案例" class="qc-case-img" />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>

    <!-- 模块10：CTA -->
    <section class="qc-cta">
      <div class="qc-cta-bg">
        <img src="/底部背景超级店长.jpg" alt="" class="qc-cta-bg-img" />
      </div>
      <div class="container-responsive qc-container qc-cta-inner">
        <AnimatedSection>
          <h2 class="qc-cta-title">开启AI零售升级之旅</h2>
          <p class="qc-cta-desc">
            各大应用商店搜索"千橙超级店长"下载体验，让AI店长为您7×24小时经营门店<br />
            覆盖21省、2.6万+乡镇、25万+会员门店
          </p>
          <div class="qc-cta-buttons">
            <router-link :to="{ name: 'QcDownload' }" class="qc-btn qc-btn-primary qc-btn-w180">
              <span class="qc-btn-text">立即下载APP</span>
              <LucideIcon name="arrow-right" :size="16" class="qc-btn-arrow" />
            </router-link>
            <a href="javascript:void(0)" class="qc-btn qc-btn-dark qc-btn-cta" @click="openContact">
              <span class="qc-btn-text">预约演示</span>
              <LucideIcon name="arrow-right" :size="16" class="qc-btn-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  </div>
</template>

<script>
import AnimatedSection from '@/components/AnimatedSection.vue'
import LucideIcon from '@/components/LucideIcon.vue'

// 零售门店四大经营痛点
const challenges = [
  {
    title: '线上商城转化难',
    desc: '线上流量成本高企，多系统并用增加70%操作负担，缺乏数智化卖货工具，转化率持续走低',
    tags: ['多平台多系统切换，操作繁琐', '商品上架慢，营销素材靠人工', '流量贵、转化低，利润被侵蚀'],
    tag: '全渠道智能卖货',
    image: '/线上商城转化难.png'
  },
  {
    title: '线下门店经营难',
    desc: '人力成本高、坪效低，导购专业度差异大，经营过度依赖个人经验，客户体验参差不齐',
    tags: ['招人难、留人难，人力成本高', '导购能力参差，服务标准不一', '营业时间受限，坪效难以突破'],
    tag: 'AI店长智能经营',
    image: '/线下门店经营难.png'
  },
  {
    title: '实体管理难',
    desc: '各系统数据孤岛林立，人工盘点易错、补货凭感觉，决策盲目，管理成本居高不下',
    tags: ['进销存数据不通，库存不准', '人工盘点效率低、差错率高', '经营数据滞后，决策凭经验'],
    tag: '数据驱动精细管理',
    image: '/实体管理难.png'
  },
  {
    title: '会员营销变现难',
    desc: '粗放营销触达不精准，私域运营重要但缺乏有效工具，老客5.3倍客单价价值未被挖掘',
    tags: ['66.7%导购认为私域运营很重要', '会员画像模糊，营销千人一面', '老客复购低，私域变现存工具短板'],
    tag: '会员全生命周期营销',
    image: '/会员营销变现难.png'
  }
]

// 千橙AI超级店长APP四大能力
const capabilities = [
  {
    icon: 'shopping-cart',
    title: '全渠道智能卖货',
    desc: '线上商城、社群、O2O多渠道一键卖货；1000+TOP品牌供应链直供，AI辅助选品上架与营销素材生成，破解流量贵、转化低',
    iconBg: '#FFA500'
  },
  {
    icon: 'message-square',
    title: 'AI店长智能经营',
    desc: '对话式指令，AI店长7×24小时自主完成经营任务；智能导购辅助、百问百答、营销策划，降低人工依赖，提升人效坪效',
    iconBg: '#FF5740'
  },
  {
    icon: 'bar-chart-3',
    title: '数据驱动精细管理',
    desc: '进销存数据一屏统览，打破数据孤岛；AI智能盘点补货、销售预测与异常预警，从"凭经验"到"看数据"科学决策',
    iconBg: '#FF8C42'
  },
  {
    icon: 'users',
    title: '会员全生命周期营销',
    desc: 'AI会员画像与智能分层，自动化场景营销；新客引流、老客复购、私域社群变现，充分挖掘老客5.3倍客单价价值',
    iconBg: '#F43F5E'
  }
]

// 全链路步骤条
const fullChainSteps = [
  {
    title: 'AI 建站运营',
    intro: '零代码+自然语言，一句话装修微商城',
    highlight: '建站周期：1 周 → 分钟级',
    image: '/超级店长-01建站运营.jpg',
    advantages: [
      '零代码+自然语言，一句话装修商城',
      '内置电商、会员、分销、LBS 模块',
      '对接微信/抖音/支付宝小程序',
      '一键部署上线，持续迭代'
    ],
    agents: ['文案能手']
  },
  {
    title: 'AI 选品上架',
    intro: '爆款选品推荐，自动补全商品信息',
    highlight: '选品上架一站式自动化',
    image: '/超级店长-02选品上架.jpg',
    advantages: [
      'AI选品：热销爆款推荐+定价建议',
      'AI上架：自动补全图片卖点，省50%人力',
      'AI调价：动态定价，销量+8%',
      '商品维护：自动信息维护迭代'
    ],
    agents: ['商品介绍', '主图设计', '促销策划']
  },
  {
    title: 'AI 自动营销',
    intro: '自动策划营销方案，一键执行落地',
    highlight: '自然语言指令，自动策划执行',
    image: '/超级店长-03自动营销.jpg',
    advantages: [
      'AI 自动营销策划，生成完整方案',
      '广告/海报/拉新素材一键生成',
      '自动执行营销，实时追踪效果',
      '数据反馈持续优化策略'
    ],
    agents: ['营销策划', '广告策划', '海报设计', '拉新策划']
  },
  {
    title: 'AI 多渠道销售',
    intro: '外呼卖货、社群推品、视频导购',
    highlight: '外呼/社群/视频全渠道覆盖',
    image: '/超级店长-04多渠道销售.jpg',
    advantages: [
      '外呼获客：AI 外呼介绍商品导购',
      '社群推品：客群标签选品自动推品',
      '视频导购：视频广告推送引导',
      '智能客服：7×24 响应辅助成交'
    ],
    agents: ['智能客服', '智能工单', '直播脚本']
  },
  {
    title: 'AI 数据分析',
    intro: '每日工作报告，自动优化经营策略',
    highlight: '每日 AI 工作报告 + 自动优化',
    image: '/超级店长-05数据分析.jpg',
    advantages: [
      '每日自动生成工作报告',
      'AI 分析营销/销售/会员数据',
      '自动给出优化建议辅助决策',
      '异常预警及时发现问题'
    ],
    agents: ['智能工单']
  },
  {
    title: 'AI 补货采购',
    intro: '智能补货建议，历史销售+未来预测',
    highlight: '历史销售+未来预测智能补货',
    image: '/超级店长-06补货采购.jpg',
    advantages: [
      '历史销售数据智能预测补货',
      'AI 给出补货建议支持自动下单',
      '智能库存管理降低缺货滞销',
      '供应链直连，支持 1 件代发'
    ],
    agents: ['进货助手']
  }
]

// AI能力数据说话
const dataCards = [
  {
    title: 'AI 智能门店',
    icon: 'store',
    data: [
      { label: '巡店效率', value: '提升 10 倍' },
      { label: '商品维护效率', value: '提升 200%' },
      { label: '补货出错率', value: '降至 1%' },
      { label: '运营效率', value: '提升 200%' }
    ]
  },
  {
    title: 'AI 智能销售',
    icon: 'trending-up',
    data: [
      { label: '高意向识别', value: '≥85%' },
      { label: '成交转化率', value: '提升≥30%' },
      { label: '服务效率', value: '提升 2 倍' },
      { label: '商品推荐准确率', value: '≥95%' }
    ]
  },
  {
    title: 'AI 智能营销',
    icon: 'megaphone',
    data: [
      { label: '素材制作效率', value: '提升≥80%' },
      { label: '商品匹配精准度', value: '≥85%' },
      { label: '营销转化率', value: '提升≥50%' },
      { label: '投放 ROI', value: '≥1:4' }
    ]
  },
  {
    title: 'AI 数据决策',
    icon: 'bar-chart-3',
    data: [
      { label: '决策周期', value: '分钟级' },
      { label: '库存周转天数', value: '≤30 天' },
      { label: '滞销/缺货损失', value: '降低≥60%' },
      { label: '客服响应时长', value: '≤10 秒' }
    ]
  }
]

// 多层级连锁门店管理体系 - 三种模式
const modeCards = [
  { icon: 'building-2', title: '直营模式', desc: '总部统一经营、统管库存', sub: '5 级区域 → 线下门店/线上商城' },
  { icon: 'users', title: '加盟模式', desc: '门店自主经营、独立库存', sub: '总部赋能 → 线下门店/线上商城' },
  { icon: 'handshake', title: '店中店联营', desc: '联动经营、共享库存', sub: '线下门店/线上商城一体化' }
]

// 六通体系
const sixTong = [
  { title: '采销通', desc: '商品库/采购/商品同步/要货', icon: 'shopping-cart' },
  { title: '会员通', desc: '会员管理/储值/等级/积分', icon: 'users' },
  { title: '营销通', desc: '会员价/接龙/优惠券/满减', icon: 'target' },
  { title: '财务通', desc: '账户/结算/分账/支付管理', icon: 'calculator' },
  { title: '数据通', desc: '经营/会员/商品/营销报表', icon: 'bar-chart-3' },
  { title: '管理通', desc: '店铺/员工/区域/权限管理', icon: 'clipboard-list' }
]

// 客户案例
const caseHighlights = [
  { title: '接单效率跃升', desc: 'AI智能路由+实时提醒，接单率提升35%' },
  { title: '夜间经济突破', desc: '延长服务时段，夜间订单贡献近3成' },
  { title: '全国门店协同', desc: '112家门店统一调度，异地订单高效履约' },
  { title: 'O2O转型成功', desc: '即时零售能力全面升级，线上营收持续增长' }
]
const caseStats = [
  { num: '+35%', label: '门店接单率提升' },
  { num: '112家', label: '异地门店覆盖' },
  { num: '28%', label: '夜间订单占比' }
]

export default {
  name: 'QianchengContent',
  components: { AnimatedSection, LucideIcon },
  data() {
    return {
      activeStep: 0,
      isMobile: false,
      challenges,
      capabilities,
      fullChainSteps,
      dataCards,
      modeCards,
      sixTong,
      caseHighlights,
      caseStats
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth < 768
    },
    isStepActive(idx) {
      return this.activeStep === idx || this.isMobile
    },
    pad2(n) {
      return String(n).padStart(2, '0')
    },
    // 打开 Header 中的联系我们弹窗（站内约定，同 LeapoAiContent）
    openContact() {
      this.$root.$emit('openContactUs', '千橙AI超级店长')
    }
  }
}
</script>

<style scoped>
/* ---------- 响应式容器（源项目为全局类，此处随组件移植） ---------- */
.container-responsive {
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 768px) {
  .container-responsive {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 1200px) {
  .container-responsive {
    max-width: 1400px;
  }
}
@media (min-width: 1600px) {
  .container-responsive {
    max-width: 1600px;
  }
}
@media (min-width: 1920px) {
  .container-responsive {
    max-width: 1800px;
  }
}

/* ---------- 通用 ---------- */
.qc-page {
  background: #ffffff;
}

.qc-container {
  max-width: 1200px;
  padding-left: 24px;
  padding-right: 24px;
  text-align: left;
}
@media (min-width: 1024px) {
  .qc-container {
    padding-left: 32px;
    padding-right: 32px;
  }
}

.qc-section {
  padding: 80px 0;
}
@media (min-width: 768px) {
  .qc-section {
    padding: 112px 0;
  }
}
.qc-section-gray {
  background: #f9fafb;
}
.qc-section-white {
  background: #ffffff;
}

.qc-section-head {
  text-align: center;
  margin-bottom: 64px;
}
.qc-section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 16px;
}
.qc-section-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
  line-height: 1.625;
}
@media (min-width: 768px) {
  .qc-section-title {
    font-size: 36px;
  }
  .qc-section-desc {
    font-size: 16px;
  }
}

.qc-grid-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .qc-grid-2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.qc-grid-3 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}
@media (min-width: 768px) {
  .qc-grid-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

.qc-grid-4 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .qc-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .qc-grid-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* 对勾 SVG */
.qc-check-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.qc-check-icon-sm {
  margin-right: 6px;
}

/* ---------- 按钮 ---------- */
.qc-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  color: #ffffff;
  text-decoration: none;
  overflow: hidden;
  transition: all 0.3s;
}
.qc-btn-primary {
  background: #ff5740;
}
.qc-btn-dark {
  background: #0a0a0a;
}
.qc-btn-w180 {
  width: 180px;
}
.qc-btn-cta {
  width: 160px;
}
@media (min-width: 768px) {
  .qc-btn-cta {
    width: 180px;
  }
}
.qc-btn-text {
  transition: transform 0.3s ease-out;
}
.qc-btn:hover .qc-btn-text {
  transform: translateX(-4px);
}
.qc-btn-arrow {
  position: absolute;
  right: 24px;
  opacity: 0;
  transform: translateX(8px);
  transition: all 0.3s ease-out;
}
.qc-btn:hover .qc-btn-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ---------- 模块1：Banner ---------- */
.qc-banner {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  height: auto;
}
@media (min-width: 768px) {
  .qc-banner {
    height: 600px;
  }
}
.qc-banner-bg {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.qc-banner-bg-img {
  width: 1690px;
  height: 600px;
  object-fit: cover;
}
.qc-banner-inner {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 120px;
  text-align: left;
}
.qc-banner-grid {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
}
@media (min-width: 768px) {
  .qc-banner-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 48px;
  }
}
.qc-banner-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.1;
  margin: 0 0 16px;
}
.qc-banner-subtitle {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.1;
  margin: 0 0 24px;
}
@media (min-width: 768px) {
  .qc-banner-title {
    font-size: 44px;
  }
  .qc-banner-subtitle {
    font-size: 56px;
  }
}
.qc-banner-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 24px;
  max-width: 560px;
}
@media (min-width: 768px) {
  .qc-banner-desc {
    font-size: 15px;
  }
}
.qc-banner-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 32px;
}
.qc-banner-stat {
  text-align: left;
}
.qc-banner-stat-num {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
}
.qc-banner-stat-label {
  font-size: 12px;
  color: #666666;
}
@media (min-width: 768px) {
  .qc-banner-stat-num {
    font-size: 24px;
  }
  .qc-banner-stat-label {
    font-size: 14px;
  }
}
.qc-banner-figure {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qc-banner-figure-img {
  width: 100%;
  height: auto;
  max-height: none;
}

/* ---------- 模块2：经营痛点 ---------- */
.qc-challenge-anim {
  height: 100%;
}
.qc-challenge-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.qc-challenge-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  z-index: 1;
}
.qc-challenge-title {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 16px;
}
@media (min-width: 768px) {
  .qc-challenge-title {
    font-size: 20px;
  }
}
.qc-challenge-desc {
  font-size: 14px;
  color: #0a0a0a;
  line-height: 1.625;
  margin: 0 0 16px;
}
.qc-challenge-tags {
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
}
.qc-challenge-tag {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.qc-challenge-tag + .qc-challenge-tag {
  margin-top: 8px;
}
.qc-challenge-bullet {
  color: #cccccc;
  margin-top: 2px;
}
.qc-challenge-foot {
  margin-top: auto;
}
.qc-challenge-pill {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px 8px 12px;
  background: linear-gradient(to right, rgba(255, 87, 64, 0.1), transparent);
  color: #ff5740;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
}
.qc-challenge-pill .qc-check-icon {
  color: #ff5740;
}
.qc-challenge-img-wrap {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 120px;
  z-index: 0;
}
@media (min-width: 768px) {
  .qc-challenge-img-wrap {
    width: 325px;
    height: 190px;
  }
}
.qc-challenge-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ---------- 模块4：APP四大能力 ---------- */
.qc-cap-card {
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  height: 100%;
}
.qc-cap-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.qc-cap-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.qc-cap-icon {
  color: #ffffff;
}
.qc-cap-title {
  font-size: 17px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-cap-title {
    font-size: 18px;
  }
}
.qc-cap-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}

/* ---------- 模块5：全链路步骤条 ---------- */
.qc-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.qc-step-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (min-width: 768px) {
  .qc-step-row {
    flex-direction: row;
    gap: 16px;
  }
}
.qc-step-tab {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 12px;
}
@media (min-width: 768px) {
  .qc-step-tab {
    width: 200px;
    justify-content: flex-end;
  }
}
.qc-step-tab-active {
  background: linear-gradient(to left, rgba(255, 87, 64, 0.1), transparent);
}
.qc-step-tab-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.qc-step-tab-text {
  text-align: right;
}
.qc-step-num {
  font-size: 20px;
  font-weight: 700;
  color: #ff5740;
  margin-bottom: 2px;
}
@media (min-width: 768px) {
  .qc-step-num {
    font-size: 24px;
  }
}
.qc-step-tab-title {
  font-size: 16px;
  font-weight: 600;
  color: #0a0a0a;
}
@media (min-width: 768px) {
  .qc-step-tab-title {
    font-size: 18px;
  }
}
.qc-step-bar {
  width: 2px;
  height: 40px;
  border-radius: 9999px;
  background: rgba(255, 87, 64, 0.2);
  transition: all 0.3s;
}
@media (min-width: 768px) {
  .qc-step-bar {
    height: 48px;
  }
}
.qc-step-bar-active {
  width: 4px;
  background: #ff5740;
}
.qc-step-card {
  flex: 1;
  transition: all 0.3s;
  background: #ffffff;
  border-radius: 16px;
}
.qc-step-card-open {
  padding: 16px;
}
@media (min-width: 768px) {
  .qc-step-card-open {
    padding: 32px;
  }
}
.qc-step-card-collapsed {
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
}
@media (min-width: 768px) {
  .qc-step-card-collapsed {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.qc-step-open {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (min-width: 768px) {
  .qc-step-open {
    flex-direction: row;
    gap: 32px;
  }
}
.qc-step-content {
  flex: 1;
}
@media (min-width: 768px) {
  .qc-step-content {
    width: 70%;
  }
}
.qc-step-content-head {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .qc-step-content-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.qc-step-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-step-title {
    font-size: 24px;
  }
}
.qc-step-highlight {
  font-size: 12px;
  color: #ff5740;
  font-weight: 500;
  background: rgba(255, 87, 64, 0.1);
  padding: 6px 16px;
  border-radius: 9999px;
  white-space: nowrap;
  align-self: flex-start;
}
@media (min-width: 768px) {
  .qc-step-highlight {
    font-size: 14px;
  }
}
.qc-step-intro {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 16px;
}
@media (min-width: 768px) {
  .qc-step-intro {
    font-size: 15px;
  }
}
.qc-step-advantages {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .qc-step-advantages {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 8px;
    row-gap: 8px;
  }
}
.qc-step-advantage {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.qc-step-check {
  color: #ff5740;
  margin-top: 2px;
}
.qc-step-advantage-text {
  font-size: 13px;
  color: #0a0a0a;
  line-height: 1.625;
}
@media (min-width: 768px) {
  .qc-step-advantage-text {
    font-size: 14px;
  }
}
.qc-step-agents {
  padding-top: 24px;
  border-top: 1px solid #eeeeee;
}
.qc-step-agents-label {
  font-size: 15px;
  color: #666666;
  margin: 0 0 12px;
}
.qc-step-agent-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.qc-step-agent {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: #f5f5f5;
  color: #0a0a0a;
  font-size: 13px;
  border-radius: 9999px;
}
@media (min-width: 768px) {
  .qc-step-agent {
    font-size: 14px;
  }
}
.qc-step-figure {
  flex-shrink: 0;
}
@media (min-width: 768px) {
  .qc-step-figure {
    width: 30%;
  }
}
.qc-step-img-box {
  width: 100%;
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
}
@media (min-width: 768px) {
  .qc-step-img-box {
    height: 260px;
  }
}
.qc-step-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.qc-step-collapsed {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
}
@media (min-width: 768px) {
  .qc-step-collapsed {
    gap: 12px;
  }
}
.qc-step-collapsed-title {
  font-size: 14px;
  font-weight: 700;
  color: #0a0a0a;
  white-space: nowrap;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-step-collapsed-title {
    font-size: 16px;
  }
}
.qc-step-collapsed-intro {
  font-size: 12px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 768px) {
  .qc-step-collapsed-intro {
    font-size: 14px;
  }
}

/* ---------- 模块6：AI能力数据说话 ---------- */
.qc-data-anim {
  height: 100%;
}
.qc-data-card {
  background: linear-gradient(to bottom, #fff8f5, #ffffff);
  border-radius: 16px;
  padding: 24px;
  height: 100%;
}
@media (min-width: 768px) {
  .qc-data-card {
    padding: 32px;
  }
}
.qc-data-head {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.qc-data-icon {
  color: #ff5740;
}
.qc-data-title {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-data-title {
    font-size: 20px;
  }
}
.qc-data-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.qc-data-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.qc-data-label {
  font-size: 14px;
  color: #666666;
}
.qc-data-value {
  font-size: 15px;
  font-weight: 700;
  margin-left: 8px;
  color: #0a0a0a;
}

/* ---------- 模块7：多层级连锁门店管理体系 ---------- */
.qc-modes {
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .qc-modes {
    margin-bottom: 80px;
  }
}
.qc-mode-card {
  text-align: center;
}
.qc-mode-icon-box {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 9999px;
  background: #fff8f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qc-mode-icon {
  color: #ff5740;
}
.qc-mode-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.qc-mode-desc {
  font-size: 15px;
  color: #666666;
  margin: 0 0 8px;
}
.qc-mode-sub {
  font-size: 14px;
  color: #999999;
  margin: 0;
}
.qc-liutong-head {
  text-align: center;
  margin-bottom: 48px;
}
.qc-liutong-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-liutong-title {
    font-size: 24px;
  }
}
.qc-liutong-grid {
  gap: 24px;
}
@media (min-width: 768px) {
  .qc-liutong-grid {
    gap: 32px;
  }
}
.qc-liutong-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  background: #f9fafb;
  height: 100%;
}
.qc-liutong-icon-box {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  background: #ff5740;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.qc-liutong-icon {
  color: #ffffff;
}
.qc-liutong-text {
  flex: 1;
}
.qc-liutong-name {
  font-size: 16px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 8px;
}
.qc-liutong-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}

/* ---------- 模块9：客户案例 ---------- */
.qc-case-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}
@media (min-width: 1024px) {
  .qc-case-grid {
    grid-template-columns: 60fr 40fr;
    gap: 48px;
  }
}
.qc-case-heading {
  margin-bottom: 24px;
}
.qc-case-label {
  font-size: 13px;
  color: #666666;
  margin-bottom: 8px;
}
@media (min-width: 768px) {
  .qc-case-label {
    font-size: 18px;
  }
}
.qc-case-title {
  font-size: 17px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.25;
  margin: 0;
}
@media (min-width: 768px) {
  .qc-case-title {
    font-size: 28px;
  }
}
@media (min-width: 1024px) {
  .qc-case-title {
    font-size: 32px;
  }
}
.qc-case-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 32px;
}
@media (min-width: 768px) {
  .qc-case-desc {
    font-size: 16px;
  }
}
.qc-case-highlights {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 32px;
}
@media (min-width: 768px) {
  .qc-case-highlights {
    grid-template-columns: repeat(2, 1fr);
  }
}
.qc-case-highlight-title {
  font-size: 15px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
@media (min-width: 768px) {
  .qc-case-highlight-title {
    font-size: 16px;
  }
}
.qc-case-check {
  color: #ff5740;
}
.qc-case-highlight-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}
.qc-case-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}
@media (min-width: 768px) {
  .qc-case-stats {
    gap: 24px;
  }
}
.qc-case-stat-num {
  font-size: 24px;
  font-weight: 700;
  color: #ff5740;
  margin-bottom: 8px;
}
@media (min-width: 768px) {
  .qc-case-stat-num {
    font-size: 32px;
  }
}
.qc-case-stat-label {
  font-size: 14px;
  color: #666666;
}
.qc-case-right {
  position: relative;
  background: linear-gradient(135deg, #fff7ed, #fef2f2);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  border-radius: 16px;
  overflow: hidden;
}
@media (min-width: 768px) {
  .qc-case-right {
    min-height: 400px;
  }
}
.qc-case-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 12px;
  background: rgba(10, 10, 10, 0.5);
  color: #ffffff;
  font-size: 11px;
  border-radius: 9999px;
  font-weight: 500;
  z-index: 10;
}
@media (min-width: 768px) {
  .qc-case-badge {
    top: 24px;
    left: 24px;
    padding: 8px 16px;
    font-size: 14px;
  }
}
.qc-case-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

/* ---------- 模块10：CTA ---------- */
.qc-cta {
  min-height: 400px;
  background: #eef0f6;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}
@media (min-width: 768px) {
  .qc-cta {
    height: 400px;
    min-height: 400px;
    padding: 0;
  }
}
.qc-cta-bg {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.qc-cta-bg-img {
  width: 1600px;
  height: 400px;
  object-fit: cover;
  object-position: center;
}
.qc-cta-inner {
  position: relative;
  z-index: 10;
  text-align: center;
}
.qc-cta-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 16px;
}
@media (min-width: 768px) {
  .qc-cta-title {
    font-size: 36px;
  }
}
.qc-cta-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
  line-height: 1.625;
}
@media (min-width: 768px) {
  .qc-cta-desc {
    font-size: 16px;
  }
}
.qc-cta-buttons {
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
@media (min-width: 768px) {
  .qc-cta-buttons {
    gap: 32px;
  }
}
</style>
